import { render, staticRenderFns } from "./CreateOrUpdateLevel.vue?vue&type=template&id=19665aac&scoped=true"
import script from "./CreateOrUpdateLevel.vue?vue&type=script&lang=js"
export * from "./CreateOrUpdateLevel.vue?vue&type=script&lang=js"
import style0 from "./CreateOrUpdateLevel.vue?vue&type=style&index=0&id=19665aac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19665aac",
  null
  
)

export default component.exports